<template lang="pug">
div
  v-form(ref="form")
    v-row(no-gutters)
      v-col(:cols="blast.enabled ? 12 : 7")
        v-card.rounded-lg.content-box.pa-6(outlined)
          v-row
            v-col(:cols="blast.enabled ? 7 : 12")
              v-row
                v-col.grow
                  div.d-flex.align-center
                    .text-md.font-semibold Whatsapp API
                    y-chip.ml-2(v-if="blastData && blast.enabled && checkPaused(blastData)" label="Paused" color="red")
                v-col.shrink(v-if="blastData && blast.enabled && checkPaused(blastData)")
                  y-button(label="Resolve" outlined size="xxs" @click="showResolveDialog = true")
                v-col.shrink
                  y-switch.mb-n3(v-model="blast.enabled")

              v-row.my-4(v-if="blast.enabled")
                v-divider.neutral300

              template(v-if="blast.enabled")
                //- Offer message
                div.text-md.font-semibold.neutral700--text Offer message
                v-textarea.text-sm.mt-2.round-xl(ref="textarea" v-model="blast.content" placeholder="Type your message here" outlined rows="6" hide-details="auto" :rules="rules.not_empty" @input="updateCursor" @change="updateCursor" @focus="updateCursor")
                div.text-sm.font-semibold.neutral700--text.mt-5 Insert field:
                v-row(no-gutters)
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('offer_name')")
                      span.neutral700--text Offer details
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('recipient_name')")
                      span.neutral700--text Customer name
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('company_name')")
                      span.neutral700--text Clinic’s name
                  v-col.shrink.pr-3.pt-2
                    v-chip(link small outlined color="neutral400" @click="insertValue('company_phone')")
                      span.neutral700--text Phone number
                  v-col.shrink.pr-3.pt-2
                    template(v-if="offer.redeem_method != 'show_message'")
                      v-chip(link small outlined color="neutral400" @click="insertValue('offer_code')")
                        span.neutral700--text Promo code
                  v-col.shrink.pr-3.pt-2
                    v-chip(v-if="offer.end_after_value && offer.end_after_unit" link small outlined color="neutral400" @click="insertValue('expiry_date')")
                      span.neutral700--text Expiry date

                v-row.my-4
                  v-divider.neutral300
                //- Image upload
                div.d-flex.align-center
                  div
                    div.text-sm.font-semibold.neutral700--text Upload image (optional)
                    div.text-sm.font-medium.neutral700--text Include an image in your message
                  v-spacer
                  div
                    y-switch(v-model="blast.image_enabled")
                v-row.mt-5(v-if="resizeImageFileUrl" dense align="center")
                  v-col.shrink
                    v-img(:src="resizeImageFileUrl" contain max-height="150" max-width="300")
                      template(v-slot:placeholder)
                        v-row(class="fill-height ma-0" align="center" justify="center")
                          v-progress-circular(indeterminate color="grey")
                  v-col
                    y-button(label="Remove" size="sm" :loading="isLoading" outlined button-class="px-3" @click="removeImage")
                v-card.round-xl.pa-8.mt-4(v-else link outlined style="border-style: dashed; border-color: var(--v-neutral400)")
                  .text-center
                    v-avatar.mb-3(color="neutral300" size="40")
                      v-icon(color="neutral500" size="18") $yzi-image-01
                    .mb-1.text-sm
                      span.info500--text.font-semibold {{ $t('click_to_upload') }}
                      span.neutral700--text {{ $t('or_drag_and_drop') }}
                    .text-xs.neutral500--text {{ $t('photo_upload_limitation') }}
                  input.input-change-layout(ref="file" type="file" @change="onFileChange" accept="image/*")

                v-row.my-4
                  v-divider.neutral300
                //- Hyperlink
                div.d-flex.align-center
                  div
                    div.text-sm.font-semibold.neutral700--text Button link (optional)
                    div.text-sm.font-medium.neutral700--text Attach a hyperlink to your message
                  v-spacer
                  div
                    y-switch(v-model="blast.hyperlink_enabled")
                v-row.mt-4
                  v-col
                    div.text-sm.font-semibold.neutral500--text Link
                    v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_url" placeholder="Enter your link" outlined dense height="48" hide-details="auto")
                  v-col
                    div.text-sm.font-semibold.neutral500--text Text on button
                    v-text-field.text-sm.round-xl.mt-2(v-model="blast.hyperlink_text" placeholder="Enter your link" outlined dense height="48" counter="20" hide-details="auto" )

            v-divider.neutral300(v-if="blast.enabled" vertical)
            //- Offer message preview
            v-col(v-if="blast.enabled" cols="5")
              whatsapp-preview(title="Offer message preview" :content="blast.content")
  .dialogs
    resolve-paused-preset-dialog(v-if="showResolveDialog" :open.sync="showResolveDialog" :preset="preset" :blast="blastData" @updated="$emit('resolved')")

</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import {resizeImage} from '@/utils'
import DatePickerField from '@/components/clinic/marketing/DatePickerField.vue'
import WhatsappPreview from '@/components/clinic/marketing/WhatsappPreview.vue'
import ResolvePausedPresetDialog from '@/components/clinic/marketing/dialogs/ResolvePausedPresetDialog.vue'

export default {
  components: { DatePickerField, WhatsappPreview, ResolvePausedPresetDialog },
  props: {
    blastData: {
      type: Object,
      default: null
    },
    sendDelaySelection: {
      type: Object,
      default: () => {
        return {
          timeValue: 1,
          timeUnit: 'hours'
        }
      }
    }
  },
  data() {
    return {
      isFetching: false,
      isLoading: false,
      showResolveDialog: false,
      resizeImageFileUrl: null,
      resizeImageFile: null,
      cursorPosition: 0,
      blast: {
        name: 'Offer message',
        send_cue: 'preset',
        type: 'offer',
        method: 'whatsapp',
        enabled: false,
      },
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 0 || `Amount should be more than ${this.$currency.symbol} 0`],
        not_empty_select: [v => !!v || 'This field is required']
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
      offer: 'marketing/getOffer'
    }),
    textarea() {
      return this.$refs.textarea.$el.querySelector('textarea')
    },
    preset () {
      return this.offer.name.toLowerCase()
    },
  },
  mounted() {
    this.setData()
  },
  methods: {
    ...mapActions(['showMessage']),
    setData() {
      if (this.blastData) {
        let blast = JSON.parse(JSON.stringify(this.blastData))
        if (blast.image) {
          this.resizeImageFileUrl = blast.image.file
        }
        this.blast = blast
      }
    },
    updateCursor() {
      const postion = this.textarea.selectionStart
      if (!postion) {
        setTimeout(() => {
          this.cursorPosition = this.textarea.selectionStart
        }, 500)
      } else {
        this.cursorPosition = this.textarea.selectionStart
      }
    },
    insertValue(value) {
      let text = ''
      const code = `{{ ${value} }}`
      if (this.blast.content) {
        text = `${this.blast.content.substring(0, this.cursorPosition)}${code}${this.blast.content.substring(this.cursorPosition, this.blast.content.length)}`
      } else {
        text = code
      }
      this.$set(this.blast, 'content', text)
    },
    deleteSchedule() {
      this.schedules.pop()
    },
    validateData() {
      return this.$refs.form.validate()
    },
    async saveData() {
      if (!this.validateData()) {
        return
      }
      if (!this.blastData && !this.blast.enabled) {
        return
      }
      this.isLoading = true
      const payload = this.getPayload()
      if (this.blast.id) {
        const {data} = await this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${this.blast.id}`, payload)
        if (this.resizeImageFile) {
          return this.updateImage(data.id)
        }
        this.isLoading = false
        return
      }
      const {data} = await this.$axios.post(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts`, payload)
      if (this.resizeImageFile) {
        return this.updateImage(data.id)
      }
      this.isLoading = false
    },
    updateImage(id) {
      let formdata = new FormData()
      formdata.append('image', this.resizeImageFile)
      return this.$axios.patch(`/marketing/${this.company.slug}/offers/${this.offer.id}/blasts/${id}`, formdata)
          .then(() => {
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    async onFileChange(e) {
      const files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      const resizedImage = await resizeImage(files[0], 'company_image.jpeg')
      this.resizeImageFileUrl = resizedImage.dataURL
      this.resizeImageFile = resizedImage.file
    },
    removeImage() {
      if (!(this.blast.image && this.blast.image.id)) {
        this.resizeImageFileUrl = null
        this.resizeImageFile = null
        return
      }
      this.isLoading = true
      this.$axios.delete(`/images/${this.blast.image.id}`)
          .then(() => {
            this.resizeImageFileUrl = null
            this.resizeImageFile = null
          })
          .catch(err => {
            let message = this.$t('error_message.unable_to_upload_image')
            if (err.response.data) {
              if (err.response.data.detail) {
                message = err.response.data.detail
              } else {
                let data = JSON.stringify(err.response.data).replace(/[^\w.\s:]/g, '').replace(/[.:]/g, match => match + ' ')
                if (data) {
                  message = data
                }
              }
            }
            this.showMessage(['error', message])
          })
          .finally(() => {
            this.isLoading = false
          })
    },
    getAutoSendDelayPayload(payload) {
      if (this.offer.name === 'First purchase' || this.offer.name === 'Second purchase') {
        payload.send_cue = 'auto_send_delay'
        payload.auto_send_delay_time_value = this.sendDelaySelection.timeValue
        payload.auto_send_delay_time_unit = this.sendDelaySelection.timeUnit
        payload.auto_send_delay_specific_time = this.sendDelaySelection.specificTime
      }
      return payload
    },
    getPayload() {
      if (!this.blast.enabled) {
        let payloadBlastDisabled = {
          enabled: false
        }
        payloadBlastDisabled = this.getAutoSendDelayPayload(payloadBlastDisabled)
        return payloadBlastDisabled
      }
      let payloadBlastEnabled = {
        enabled: true,
        name: this.blast.name,
        method: this.blast.method,
        type: this.blast.type,
        content: this.blast.content,
        send_cue: this.blast.send_cue,
        image_enabled: this.blast.image_enabled,
        hyperlink_enabled: this.blast.hyperlink_enabled,
        hyperlink_url: this.blast.hyperlink_url,
        hyperlink_text: this.blast.hyperlink_text,
        schedules: [],
      }
      payloadBlastEnabled = this.getAutoSendDelayPayload(payloadBlastEnabled)
      return payloadBlastEnabled
    },
    checkPaused (data) {
      let paused = false
      if (data.schedules.find(f => f.status === 'paused')) {
        paused = true
      }
      return paused
    },
  },
}
</script>

<style lang="scss" scoped>
.input-change-layout {
  position: absolute;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  opacity: 0;
}

::v-deep {
  .v-text-field--outlined {
    fieldset {
      border-color: var(--v-neutral400);
    }
  }

  .error--text {
    color: var(--v-danger500) !important;

    fieldset {
      border-color: var(--v-danger500);
    }
  }
}
</style>